var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-container",on:{"dblclick":_vm.back}},[_c('div',{ref:"map_ref",staticClass:"com-chart"},[_vm._v("1111")])])}
var staticRenderFns = []

export { render, staticRenderFns }